import Vue from 'vue';
import Vuex from 'vuex';

import entry from './modules/entry';

Vue.use( Vuex );

export default new Vuex.Store({
    strict: true,

    modules: {
        entry
    },

    state: {

    },

    getters: {

    },

    mutations: {

    },

    actions: {

    }
});
